import React, { useEffect, useState } from 'react';
import BurgerMenu from '../../commons/BurgerMenu';
import { Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Link, Route, Switch, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import SignalsAdminCondos from './SignalsAdminCondo';
import axios from 'axios';
import { useLoading } from '../../commons/Loading';
import { useAlert } from 'react-alert';
import { useAuth } from '../../commons/Auth';
import './ProfileDetail.scss';
import './TabsProfile.scss';
import Footer from '../../commons/Footer';
import Header from '../../commons/Header';
import variables from '../../variables';
import { ReactComponent as IcnDocument } from '../../images/icn_document.svg';
import { ContFlexLeft } from '../../styled-components';
import ModalNewSignal from './ModalNewSignal';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import SignalsAdminSpecialJobs from './SignalsAdminSpecialJobs';
import SignalsAdminRentalsSales from './SignalsAdminRentalsSales';
import classNames from 'classnames';
import { getSignedUrl } from '../../lib/fetch/files';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const SignalsAdmin = (props) => {
  const [t] = useTranslation('SIGNALS');
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();
  const [{ newToken, newIsAdmin } = {}] = useAuth();

  const { history, location, match = {} } = props;
  const { params: { id } = {}, url = '' } = match;
  const { pathname = '', state = {} } = location;
  const tab = pathname.split('/').pop();

  const [signals, setSignals] = useState([]);
  const [signalTypes, setSignalTypes] = useState([]);
  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    signalman: withDefault(StringParam, ''),
    admin: withDefault(StringParam, ''),
    commercial: withDefault(StringParam, ''),
    condo: withDefault(StringParam, ''),
    signalTypeCode: withDefault(StringParam, 'CONDO'),
    accountabilityYear: NumberParam,
    accountabilityMonth: NumberParam,
    notes: withDefault(StringParam, ''),
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
  });

  const {
    signalman,
    commercial,
    admin,
    condo,
    signalTypeCode,
    accountabilityYear,
    accountabilityMonth,
    limit,
    offset,
    notes,
  } = query;

  function onFilter(queryDiff) {
    if (
      (queryDiff.signalman && queryDiff.signalman !== signalman) ||
      (signalman && queryDiff.signalman === '') ||
      (queryDiff.commercial && queryDiff.commercial !== commercial) ||
      (commercial && queryDiff.commercial === '') ||
      (queryDiff.admin && queryDiff.admin !== admin) ||
      (admin && queryDiff.admin === '') ||
      (queryDiff.notes && queryDiff.notes !== notes) ||
      (notes && queryDiff.notes === '') ||
      (queryDiff.condo && queryDiff.condo !== condo) ||
      (condo && queryDiff.condo === '') ||
      (queryDiff.signalTypeCode &&
        queryDiff.signalTypeCode !== signalTypeCode) ||
      (signalTypeCode && queryDiff.signalTypeCode === '') ||
      (queryDiff.accountabilityYear &&
        queryDiff.accountabilityYear !== accountabilityYear) ||
      (accountabilityYear && queryDiff.accountabilityYear === '') ||
      (queryDiff.accountabilityMonth &&
        queryDiff.accountabilityMonth !== accountabilityMonth) ||
      (accountabilityMonth && queryDiff.accountabilityMonth === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  const fetchSignals = async (query) => {
    showLoading();

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/signals/admin`,
      {
        headers: { Authorization: newToken },
        params: {
          ...query,
        },
      }
    );

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [], headers = {} } = response;
    setSignals(data.signals || []);
    setTotal(+headers['x-total-count']);
  };

  const deleteFileConfirm = async (data) => {
    showLoading();

    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/signals/file`,
      data,
      {
        headers: { Authorization: newToken },
      }
    );
    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    alert.success(t('COMMON:SUCCESS_UPDATE'));
    fetchSignals(query);
  };

  const searchSignalmens = async (data) => {
    const { value, signalType, excludeIds = [] } = data;
    const response_signalmans = await axios.post(
      `${process.env.REACT_APP_API_URL}/profiles/signalmans`,
      {
        search: value,
        signalType,
        // excludeIds
      },
      {
        headers: { Authorization: newToken },
      }
    );

    if (response_signalmans instanceof Error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return [];
    }

    const { data: signalmans = [] } = response_signalmans;

    return signalmans;
  };

  const searchCondos = async (value) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/condos`,
      {
        headers: { Authorization: newToken },
        params: { search: value },
      }
    );

    if (response instanceof Error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return [];
    }

    const { data = [] } = response;
    return data.condos || [];
  };

  const searchAdmins = async (value) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/profiles/admins`,
      {
        headers: { Authorization: newToken },
        params: { search: value },
      }
    );

    if (response instanceof Error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return [];
    }

    const { data = [] } = response;
    return data;
  };

  const fetchSignalTypes = async () => {
    showLoading();

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/signals/types`,
      {
        headers: { Authorization: newToken },
      }
    );

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [] } = response;
    setSignalTypes(data.signalTypes || []);
  };

  const createSignal = async (data) => {
    showLoading();

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/signals`,
      data,
      {
        headers: {
          Authorization: newToken,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    alert.success(t('COMMON:SUCCESS_CREATE'));
    fetchSignals(query);
  };

  const updateSignal = async (data) => {
    showLoading();
    const signalId = data.get('_id');

    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/signals/${signalId}`,
      data,
      {
        headers: { Authorization: newToken },
      }
    );
    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    alert.success(t('COMMON:SUCCESS_UPDATE'));
    fetchSignals(query);
  };

  const checkVatCode = async (vatCode, toggle) => {
    showLoading();

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/condos/checkVatCode`,
      {
        vatCode: vatCode,
      },
      {
        headers: { Authorization: newToken },
      }
    );

    hideLoading();

    if (response instanceof Error) {
      throw new Error('Errore nel controllo della partita IVA');
    }

    return response.data;
  };

  async function handleFileListView(key) {
    showLoading();

    const { data, error } = await getSignedUrl(key, newToken);

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    hideLoading();
    window.open(data.url, '_blank');
  }

  useEffect(() => {
    if (signalTypes.length === 0) {
      fetchSignalTypes();
    }
  }, []);

  useEffect(() => {
    fetchSignals(query);
  }, [
    signalman,
    commercial,
    admin,
    condo,
    signalTypeCode,
    accountabilityYear,
    accountabilityMonth,
    notes,
    limit,
    offset,
  ]);

  if (pathname === url) {
    return <Redirect to={`${url}/condos`} />;
  }

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:SIGNALS')}
            icon={<IcnDocument fill={variables.white} />}
          />
        </section>
        <section>
          <Row className="align-items-center mb-3">
            <Col sm="12">
              <ContFlexLeft>
                <ModalNewSignal
                  onConfirm={createSignal}
                  checkVatCode={checkVatCode}
                  searchSignalmens={searchSignalmens}
                  searchCondos={searchCondos}
                  searchAdmins={searchAdmins}
                  signalTypes={signalTypes}
                />
              </ContFlexLeft>
            </Col>
          </Row>
        </section>
        <section>
          <div className="m-tb-20">
            <Nav tabs>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/condos?signalTypeCode=CONDO`}
                  className={classNames({ active: tab === 'condos' })}
                >
                  {t('PAGES:SIGNALS_CONDO_TAB')}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/special-jobs?signalTypeCode=SPECIAL_JOBS`}
                  className={classNames({ active: tab === 'special-jobs' })}
                >
                  {t('PAGES:SIGNALS_SPECIAL_JOBS_TAB')}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/rentals-sales?signalTypeCode=RENTALS_SALES`}
                  className={classNames({ active: tab === 'rentals-sales' })}
                >
                  {t('PAGES:SIGNALS_RENTALS_SALES_TAB')}
                </NavLink>
              </NavItem>
            </Nav>

            <Switch>
              <Route
                path={`${match.url}/condos`}
                component={(props) => (
                  <SignalsAdminCondos
                    signals={signals}
                    signalTypes={signalTypes}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    onUpdateSignal={updateSignal}
                    checkVatCode={checkVatCode}
                    searchSignalmens={searchSignalmens}
                    searchCondos={searchCondos}
                    searchAdmins={searchAdmins}
                    handleFileListView={handleFileListView}
                    deleteFileConfirm={deleteFileConfirm}
                    {...props}
                  />
                )}
              />

              <Route
                path={`${match.url}/special-jobs`}
                component={(props) => (
                  <SignalsAdminSpecialJobs
                    signals={signals}
                    signalTypes={signalTypes}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    onUpdateSignal={updateSignal}
                    searchSignalmens={searchSignalmens}
                    searchAdmins={searchAdmins}
                    handleFileListView={handleFileListView}
                    deleteFileConfirm={deleteFileConfirm}
                    {...props}
                  />
                )}
              />

              <Route
                path={`${match.url}/rentals-sales`}
                component={(props) => (
                  <SignalsAdminRentalsSales
                    signals={signals}
                    signalTypes={signalTypes}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    onUpdateSignal={updateSignal}
                    searchSignalmens={searchSignalmens}
                    searchAdmins={searchAdmins}
                    handleFileListView={handleFileListView}
                    deleteFileConfirm={deleteFileConfirm}
                    {...props}
                  />
                )}
              />
            </Switch>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default withRouter(SignalsAdmin);
